import { useInterceptor, getAuthToken } from "@/api/login.api"
import { getByEmail, forgottenPassword, updatePassword } from "@/api/personas.api"
import JwtUtils from "@/mixins/JwtUtils"


const state = {

    logged: false,
    user: null,
    token: null,
    persona: null,
    solicitante: null

}

const getters = {

    /**
     * Return login state
     * 
     */

    getLogin(state) {

        return state.logged

    },

    /**
     * Return the logged user
     * 
     */

    getUser(state) {

        return state.user

    },

    /**
     * Return the logged persona
     * 
     */

    getPersona(state) {

        return state.persona

    },

    /**
     * Return the id of the solicitante
     * 
     */

    getSolicitanteId(state) {

        return state.solicitante

    }

}

const actions = {

    /**
     * Get token for user from the API
     * 
     */

    async loginUser({ dispatch, commit },{username,password,componentId}) {

        try {

            const response = await getAuthToken(username,password)

            if(response.status == 200) {

                let login = useInterceptor(response.data.token)

                const jwt = new JwtUtils()
                const jwtPayload = jwt.getJwtTokenInfo(response.data.token)

                commit('SET_LOGIN', { state: true, username: username, token: response.data.token })

                return login

            } else if (response.status != 401) {

                dispatch('Errors/setError', { error:'CODE03', componentId: componentId }, { root: true })

                return false

            }

        } catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')

            let error_code = error.response.data.message

            if( error_code == "Invalid credentials." ) error_code = "CODE01"
            if( error_code == undefined ) error_code = "CODE03"

            dispatch('Errors/setError', { error: error_code, componentId: componentId }, { root: true })

            return false

        }    

    },

    /**
     * Get persona by token
     * 
     */

    async getPersonaLogged({ dispatch, commit, state }, {componentId}) {

        try {

            const query = await getByEmail(state.user.username)

            commit('SET_SOLICITANTE', query.data[0].id)
            commit('SET_PERSONA', query.data[0])
            dispatch('Matricula/setSolicitante', query.data[0].id, { root: true })

            return true

        }  catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

        }

    },

    /**
     * Send email to regenerate password
     * 
     */

    async newPassWordPlease({ dispatch },{ email, locale, componentId }) {

        try {

            const query = await forgottenPassword(email,locale)

            if(query.status == 200) {

                if( query.data.status == "success" ) {

                    return true

                } else {

                    return false

                }

            }

        } catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

        }

    },

    /**
     * Update the password of a user
     * 
     */

    async updatePassWordPlease({ dispatch },{ token, password, componentId }) {

        try {

            const query = await updatePassword(token,password)

            if(query.status == 200) {

                return true

            } else {

                return false

            }

        } catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

        }

    }

}

const mutations = {

    /**
     * Change the login state
     * 
     */
    
    SET_LOGIN(state, data) {

        localStorage.setItem('logged', JSON.stringify(data))

        state.logged = true
        state.user = data

    },

    SET_PERSONA(state, data) {

        state.persona = data

    },

    SET_SOLICITANTE(state, id) {

        localStorage.setItem('solicitante', id)

        state.solicitante = id

    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
